import { useBreadcrumbs } from 'src/hooks/useBreadcrumbs';
import { useQCTaskHook } from '../hooks/useQCTask.hook';
import { DXAPageView } from './DXAPage.view';
export const DXAPage = () => {
  const { clinicalTrialId, taskId, patientData, patientDataIsLoading, visitName } =
    useQCTaskHook();

  useBreadcrumbs(
    [
      ['QC List', 'qcTasks'],
      [patientData?.patientCode ?? '...', 'qcTaskInfo'],
      [visitName ?? '...', 'qcTaskInfo'],
      ['DXA QC', 'qcTaskDXA'],
    ],
    [clinicalTrialId ?? '', taskId ?? '']
  );

  if (!clinicalTrialId || !taskId) {
    return null;
  }
  return (
    <DXAPageView
      loading={patientDataIsLoading}
      clinicalTrialId={clinicalTrialId}
      taskId={taskId}
    />
  );
};
